// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "MapLegend-module--wrapper--xi+26";
export var item = "MapLegend-module--item--CUrqE";
export var text = "MapLegend-module--text--8akz8";
export var radius = "MapLegend-module--radius--AGbx3";